<template>
  <div
    class="flex flex-row items-end justify-center w-full lg:w-1/2 h-full p-2 lg:p-4 animate-pulse"
  >
    <!-- Second Position -->
    <div class="relative flex flex-col items-center justify-end h-full">
      <div
        class="rounded-full w-12 h-12 md:w-20 md:h-20 mb-2 flex items-center justify-center bg-gray-300"
      ></div>
      <span class="h-4 w-20 bg-gray-300 rounded mb-2"></span>
      <span class="h-4 w-24 bg-gray-300 rounded"></span>
      <div
        class="podium-second widthPodiumMobile md:w-52 lg:w-40 xl:w-52 xxl:w-64 rounded-l-lg flex flex-col items-center justify-between mt-8 py-4 bg-gray-200"
      ></div>
    </div>

    <!-- First Position -->
    <div class="relative flex flex-col items-center justify-end h-full">
      <div
        class="rounded-full w-12 h-12 md:w-20 md:h-20 mb-2 flex items-center justify-center bg-gray-300"
      ></div>
      <span class="h-4 w-20 bg-gray-300 rounded mb-2"></span>
      <span class="h-4 w-24 bg-gray-300 rounded"></span>
      <div
        class="podium-first widthPodiumMobile md:w-52 lg:w-40 xl:w-52 xxl:w-64 rounded-t-lg flex flex-col items-center justify-between mt-8 py-4 bg-gray-200"
      ></div>
    </div>

    <!-- Third Position -->
    <div class="relative flex flex-col items-center justify-end h-full">
      <div
        class="rounded-full w-12 h-12 md:w-20 md:h-20 mb-2 flex items-center justify-center bg-gray-300"
      ></div>
      <span class="h-4 w-20 bg-gray-300 rounded mb-2"></span>
      <span class="h-4 w-24 bg-gray-300 rounded"></span>
      <div
        class="podium-third widthPodiumMobile md:w-52 lg:w-40 xl:w-52 xxl:w-64 custom-rounded-r flex flex-col items-center justify-between mt-8 py-4 bg-gray-200"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonPlacementPodium',
};
</script>

<style scoped>
.podium {
  height: auto;
}

.widthPodiumMobile {
  width: 25vw;
}

.podium-first {
  min-height: 480px;
}

.podium-second {
  min-height: 380px;
}

.podium-third {
  min-height: 300px;
}

.bg-gray-200 {
  background-color: #e2e8f0;
}

.bg-gray-300 {
  background-color: #cbd5e0;
}

.custom-rounded-l {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.custom-rounded-r {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
</style>
